module.exports = __webpack_public_path__ + "img/icon-redo.69bb9af6.svg";